import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Image,
  Popup,
  Modal,
  Header,
  Input,
  Dropdown,
} from "semantic-ui-react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
  deleteUserData,
  DeleteUserSuccess,
  updateUser,
  UpdateUserRequestSuccess,
} from "../../actions/dataConsoleAction";

const ListView = ({ data, showToaster, setDeleteStatusFlag }) => {
  const dispatch = useDispatch();
  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [deleteUserName, setdeleteUserName] = useState("");
  const [deleteUserId, setdeleteUserId] = useState("");
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [openUserEditBox, setopenUserEditBox] = useState(false);
  const [inputUsername, setInputUsername] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputRole, setInputRole] = useState("");
  const [EditUserId, setEditUserId] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [userId, setUserId] = useState("");

  const { deleteB2cUserData, deleteUserStatus } = useSelector(
    (state) => state.deleteB2cUser || {}
  );

  const { updateUserResponse, updateUserStatus } = useSelector(
    (state) => state.updateUserReducer || {}
  );

  useEffect(() => {
    if (deleteUserStatus === 200 && deleteStatus) {
      showToaster(`${deleteUserName} deleted successfully`, "success");
      setDeleteStatus(false);
      setDeleteStatusFlag(true);
      DeleteUserSuccess([]);
    }
  }, [deleteUserStatus, deleteStatus]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const code = jwtDecode(token);
      if (code.oid !== undefined) {
        setUserId(code.oid); // Set userId in state
      }
    }
  }, []);

  useEffect(() => {
    if (updateUserStatus === 200) {
      dispatch(UpdateUserRequestSuccess([]));
      showToaster("User updated successfully", "success");
      setDeleteStatusFlag(true);
    }
  }, [updateUserResponse, updateUserStatus]);

  const handleDeleteUser = async (userName, userID) => {
    setdeleteUserName(userName);
    setdeleteUserId(userID);
    setopenDeleteBox(true);
  };

  const handleClose = () => {
    setopenDeleteBox(false);
  };

  const actionDeleteUser = async () => {
    setopenDeleteBox(false);
    setDeleteStatus(true);
    dispatch(deleteUserData(deleteUserId));
  };

  const handleEditUser = (row) => {
    setopenUserEditBox(true);
    setEditUserId(row.id);
    setInputUsername(row.displayName);
    setInputEmail(row.email);
    setInputRole(row.role);
  };

  const handleChangeRole = (e, { value }) => {
    setInputRole(value);
  };

  const handleChangeName = (e) => {
    setInputUsername(e.target.value);
    if (e.target.value.length > 0) {
      setUsernameError(false);
    } else {
      setUsernameError(true);
    }
  };

  const handleCloseUserBox = () => {
    setopenUserEditBox(false);
  };

  const handleUpdateUser = () => {
    if (inputUsername.length > 0) {
      setopenUserEditBox(false);
      const payload = {
        displayName: inputUsername,
        role: inputRole,
      };
      dispatch(updateUser(payload, EditUserId));
    } else {
      setUsernameError(true);
    }
  };

const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  return (
    <>
      <Grid columns={3} stackable className="users-table mobile-users-table">
        {sortedData.length > 0
          ? sortedData.map((row) => (
              <Grid.Column key={row.id}
              data-cy="user-list-cy">
                <Card fluid className="qac-card">
                  <Card.Content className="qac-card-content">
                    <Card.Header>
                      <div className="userListCardHeader">
                        <div className="userListCardRow">{row.displayName}</div>
                        <div>
                        {row.role === "Admin" ? (
                            <>
                              <div className="user-admin-box">
                                <img
                                  src="/images/user-admin-box.svg"
                                  alt="Admin Icon"
                                />
                                <span className="usersRoleBox">Admin</span>
                              </div>
                            </>
                          ) : row.role === "DatasetAdmin" ? (
                            <>
                              <div className="user-admin-box">
                                <img
                                  src="/images/user-admin-box.svg"
                                  alt="DatasetAdmin Icon"
                                />
                                <span className="usersRoleBox">Dataset Admin</span>
                              </div>
                            </>     
                          ) : row.role === "OrgAdmin" ? (
                            <>
                              <div className="user-admin-box">
                                <img
                                  src="/images/user-admin-box.svg"
                                  alt="OrgAdmin Icon"
                                />
                                <span className="usersRoleBox">Org Admin</span>
                              </div>
                            </>
                          ) : row.role === "QuickChatUser" ? (
                            <>
                              <div className="user-admin-box">
                                <img
                                  src="/images/user-admin-box.svg"
                                  alt="QuickChatUser Icon"
                                />
                                <span className="usersRoleBox">Quick Chat User</span>
                              </div>
                            </>
                          ) : row.role === "HumanAgent" ? (
                            <>
                              <div className="user-admin-box">
                                <img
                                  src="/images/user-admin-box.svg"
                                  alt="HumanAgent Icon"
                                />
                                <span className="usersRoleBox">Human Agent</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="user-user-box">
                                <img
                                  src="/images/user-user-box.svg"
                                  alt="User Icon"
                                />
                                <span className="usersRoleBox">User</span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Meta>
                      <div>
                        <span className="userEmail">
                          {row.email && row.email.length > 20 ? (
                            <Popup
                              trigger={<span>{row.email.slice(0, 20)}...</span>}
                              content={row.email}
                              position="top center"
                              inverted
                            />
                          ) : (
                            row.email
                          )}
                        </span>
                      </div>
                    </Card.Meta>
                  </Card.Content>
                  <Card.Content extra className="qac-card-extra-content">
                    <div className="userListCardFooter">
                      <div className="userListCardFooterRow">
                        Created on:{" "}
                        {moment(row.createdAt).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}
                      </div>
                      <div className="user-card-icons grey-icons">
                        {row.role !== "OrgAdmin" && ( // Check if the row.role is not "OrgAdmin"
                          <>
                            <div>
                              <img
                                className="tableButton"
                                src="/images/Edit.svg"
                                alt="Edit"
                                onClick={() => {
                                  handleEditUser(row);
                                }}
                                style={{ cursor: "pointer" }}
                                data-cy="user-edit-link"
                              />
                            </div>
                            {userId !== row.id && (
                              <div>
                                <img
                                  className="tableButton"
                                  src="/images/grey-delete.svg"
                                  onClick={() => {
                                    handleDeleteUser(row.displayName, row.id);
                                  }}
                                  alt="Delete"
                                  style={{ cursor: "pointer" }}
                                  data-cy="user-delete-link"
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      <div className="user-card-icons color-icons">
                        {row.role !== "OrgAdmin" && ( // Check if the row.role is not "OrgAdmin"
                          <>
                            <div>
                              <img
                                className="tableButton"
                                src="/images/blue-pen.svg"
                                alt="Edit"
                                onClick={() => {
                                  handleEditUser(row);
                                }}
                                style={{ cursor: "pointer" }}
                                data-cy="user-delete-link"
                              />
                            </div>
                            {userId !== row.id && (
                              <div>
                                <img
                                  className="tableButton"
                                  src="/images/delete-red.svg"
                                  onClick={() => {
                                    handleDeleteUser(row.displayName, row.id);
                                  }}
                                  alt="Delete"
                                  style={{ cursor: "pointer" }}
                                  data-cy="user-delete-link"
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))
          : ""}
      </Grid>
      <Modal
        open={openDeleteBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Delete User</Header>

          <p>Are you sure you want to Delete "{deleteUserName}"</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-user-delete"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={actionDeleteUser}
            data-cy="user-dataset-confirm"
          >
            Delete
          </button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openUserEditBox}
        onClose={handleCloseUserBox}
        size="tiny"
        className="add-document-model"
      >
        <Modal.Content>
          <Header as="h3">
            Edit User{" "}
            {inputEmail.length > 20 ? (
              <Popup
                trigger={<span>{inputEmail.slice(0, 20)}...</span>}
                content={inputEmail}
                position="top center"
                inverted
              />
            ) : (
              <span>{inputEmail}</span>
            )}
          </Header>
          <label>Username</label>
          <br />
          <Input
            type="text"
            name="username"
            value={inputUsername}
            onChange={handleChangeName}
            placeholder="Add name"
            className="add-datset-input"
            error={usernameError}
            data-cy="edit-user-username-cy"
          />
          {usernameError && (
            <span style={{ color: "red" }}>Username is required</span>
          )}
          <br />
          <br />
          <label>Access</label>
          <Dropdown
            placeholder="Select "
            fluid
            selection
            name="access"
            options={[
              { key: "1", text: "Admin", value: "Admin" },
              { key: "3", text: "DatasetAdmin", value: "DAdmin" },
              { key: "2", text: "User", value: "User" },
              { key: "4", text: "HumanAgent", value: "HumanAgent" },
            ]}
            value={inputRole}
            onChange={handleChangeRole}
            data-cy="edit-user-dropdown-cy"
          />
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleCloseUserBox}
            data-cy="edit-cancel-user-delete"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={handleUpdateUser}
            data-cy="edit-delete-user-confirm"
          >
            Save
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ListView;
